/**
 * @render react
 * @name RelatedLinks
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniqid from 'uniqid';

import { withPolaris } from 'Components/protons/Polaris';

import { Image } from 'Components/atoms/Image';
import { Link } from 'Components/molecules/Link';

import './_style.scss';

/**
 * RelatedLinks component
 * @param {string} title - Title of the component
 * @param {boolean} loadStyles - Whether to apply the class names for styling
 * @param {Object} extraClassNames - Extra class names to be applied to the component
 * @param {Object} context - Extra information coming from Polaris provider.
 */
const RelatedLinks = ({
  content,
  context: { cssPrefix },
  extraClassNames,
  imageSize,
  loadStyles,
  title,
}) => (
  <div
    className={classNames({
      [`${cssPrefix}__related-links`]: loadStyles,
      ...extraClassNames,
    })}
  >
    {title && <p className={`${cssPrefix}__related-links--title`}>{title}</p>}
    <ul className={`${cssPrefix}__related-links--list`}>
      {content.map((link, index) => (
        <li className={`${cssPrefix}__related-links--list-item`} key={uniqid(`related-links-${index}`)}>
          {link.image && (
            <div className={`${cssPrefix}__related-links--image`}>
              <Image
                {...link.image}
                size={imageSize}
                ampLayout="flex-item"
              />
            </div>
          )}
          <Link href={link.url}>{link.label}</Link>
          {link.author && (
            <div className={`${cssPrefix}__related-links--author-container`}>
              {link.author.image && <Image {...link.author.image} imageSize="author-small" /> }
              <span className={`${cssPrefix}__related-links--author`}>{link.author.name}</span>
            </div>
          )}
        </li>
      ))}
    </ul>
  </div>
);

RelatedLinks.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape()),
  context: PropTypes.shape(),
  extraClassNames: PropTypes.shape(),
  imageSize: PropTypes.string,
  loadStyles: PropTypes.bool,
  title: PropTypes.string,
};

RelatedLinks.defaultProps = {
  content: [],
  context: {},
  extraClassNames: {},
  imageSize: 'related-embed',
  loadStyles: true,
  title: null,
};

export default withPolaris(RelatedLinks);
